/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import QueryStringFilter from 'Helpers/QueryStringFilter'
import { IArmazem } from 'Models/docas'
import IArmazemTipo from 'Models/docas/IArmazemTipo'
import { ParamsRequest } from 'Services/__shared/types/resquest'
import ApiService from 'Services/ApiService'
import {
  ServiceCreateResponse,
  ServiceDetailsResponse,
  ServiceListResponse,
} from 'Types/ServiceResponse'

import IFormDocasArmazemTipoFilter from './types/resquest/IFormDocasArmazemTipoFilter'
import IFormDocasCandidatosFilter from './types/resquest/IFormDocasCandidatosFilter'

const armazem = {
  getList: async (
    idComponente: number,
    filter?: IFormDocasCandidatosFilter,
    params?: ParamsRequest,
  ) => {
    let localFilters: IFormDocasCandidatosFilter | undefined
    if (filter) {
      localFilters = filter
    }

    const result: AxiosResponse<ServiceListResponse<IArmazem>> =
      await ApiService({ idComponente }).get<ServiceListResponse<IArmazem>>(
        QueryStringFilter(`${hosts.WS_DOCAS}/armazem`, localFilters, params),
      )

    return result
  },

  getListTypes: async (
    idComponente: number,
    filter: IFormDocasArmazemTipoFilter = { apenasAtivos: true },
  ) => {
    const result: AxiosResponse<ServiceListResponse<IArmazemTipo>> =
      await ApiService({ idComponente }).get<ServiceListResponse<IArmazemTipo>>(
        QueryStringFilter(`${hosts.WS_DOCAS}/armazem_tipo`, filter),
      )

    return result
  },

  details: async (idComponente: number, id: number, data: string) => {
    const result: AxiosResponse<ServiceDetailsResponse<IArmazem>> =
      await ApiService({ idComponente }).get<ServiceDetailsResponse<IArmazem>>(
        `${hosts.WS_DOCAS}/armazem/${id.toString()}/${data}`,
      )

    return result
  },

  create: async (idComponente: number, armazem: any) => {
    const result: AxiosResponse<ServiceCreateResponse> = await ApiService({
      idComponente,
    }).post<ServiceCreateResponse>(`${hosts.WS_DOCAS}/armazem`, armazem)

    return result
  },

  update: async (idComponente: number, armazem: any) => {
    const result: AxiosResponse<ServiceCreateResponse> = await ApiService({
      idComponente,
    }).put<ServiceCreateResponse>(`${hosts.WS_DOCAS}/armazem`, armazem)

    return result
  },

  getFutureConfigurations: async (idComponente: number, cdArmazem: number) => {
    const result: AxiosResponse<ServiceListResponse<IArmazem>> =
      await ApiService({
        idComponente,
      }).get<ServiceListResponse<IArmazem>>(
        `${hosts.WS_DOCAS}/armazem_config_futuras/${cdArmazem}`,
      )

    return result
  },
}

export default armazem
